import React from 'react';
import { number, bool } from 'prop-types';
import { RectShape } from '@thd-olt-component-react/loading-placeholder';
import { Col } from '@thd-olt-component-react/core-ui';

export const OrderAPackageLoader = ({ podsCount, isMobile }) => (
  <Col data-component="OrderAPackageLoader">
    <Col>
      <Col>
        <RectShape style={{ width: '100%', height: '70px', margin: '20px 0 10px 0' }} color="white" />
      </Col>
      <Col md="8" lg="8" flatten>
        <Col nopadding>
          {[...Array(podsCount)].map((n, i) => {
            return (
              <RectShape key={i} style={{ width: '100%', height: '275px', marginBottom: '10px' }} color="white" />
            );
          }
          )}
        </Col>
      </Col>
      <Col md="4" lg="4" nopadding>
        <RectShape
          style={{ width: '100%', height: (isMobile ? '350px' : '700px'), marginBottom: '10px' }}
          color="white"
        />
      </Col>
    </Col>
  </Col>
);

OrderAPackageLoader.propTypes = {
  podsCount: number,
  isMobile: bool
};

OrderAPackageLoader.defaultProps = {
  podsCount: 4,
  isMobile: false
};

OrderAPackageLoader.displayName = 'OrderAPackageLoader';